import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { endpoints } from '@api/apis';

export const checkCustomerEligibilityAPI = async (payload: {
  applicationId: string;
}) => {
  const applicationIdStored = await AsyncStorage.getItem("application_id")
  const applicationId = applicationIdStored ?? payload.applicationId
  return await axios.get(`${endpoints.checkCustomerEligibility}${applicationId}`);
}
